export const START = `_START`;
export const SUCCESS = `_SUCCESS`;
export const FAIL = `_FAIL`;
export const TICK = `_TICK`;
export const INIT_CANVAS = `INIT_CANVAS`;
export const APPLY_CONDITION_TO_CANVAS = `APPLY_CONDITION_TO_CANVAS`;
export const APPLY_CONDITION_TO_SIDES = `APPLY_CONDITION_TO_SIDES`;
export const PRODUCT_READY = `PRODUCT_READY`;
export const LOAD_DATA = `LOAD_DATA`;
export const CHANGE_SIDE = `CHANGE_SIDE`;
export const CHANGE_PRODUCT = `CHANGE_PRODUCT`;
export const CHANGE_DESIGN = `CHANGE_DESIGN`;
export const CHANGE_VARIANT = `CHANGE_VARIANT`;
export const SAVE_DESIGN = `SAVE_DESIGN`;
export const AUTO_SAVE_DESIGN = `AUTO_SAVE_DESIGN`;
export const CLEAR_DESIGN = `CLEAR_DESIGN`;
export const GET_REALISM = `GET_REALISM`;
export const ADD_MESSAGE = `ADD_MESSAGE`;
export const CHANGE_BACKGROUND_FOR_OTHER_SIDES = `CHANGE_BACKGROUND_FOR_OTHER_SIDES`;
export const ADD_PICTURE_TO_CANVAS = `ADD_PICTURE_TO_CANVAS`;
export const UPLOAD_IMAGE = `UPLOAD_IMAGE`;
export const ADD_IMAGE = `ADD_IMAGE`;
export const REMOVE_IMAGE = `REMOVE_IMAGE`;
export const TOGGLE_MODAL = `TOGGLE_MODAL`;
export const CLOSE_ALL_MODALS = `CLOSE_ALL_MODALS`;
export const UPDATE_UNDO_REDO = `UPDATE_UNDO_REDO`;
export const UNDO = `UNDO`;
export const REDO = `REDO`;
export const ADD_TEXT = `ADD_TEXT`;
export const CHANGE_TEXT = `CHANGE_TEXT`;
export const TOGGLE_EFFECT = `TOGGLE_EFFECT`;
export const SET_OPACITY = `SET_OPACITY`;
export const SET_FILL = `SET_FILL`;
export const TOGGLE_PRODUCTS = `TOGGLE_PRODUCTS`;
export const SET_STROKE = `SET_STROKE`;
export const CHANGE_SOURCE_UPLOADER = `CHANGE_SOURCE_UPLOADER`;
export const THIRD_PARTY_SEARCH = `THIRD_PARTY_SEARCH`;
export const SET_THIRD_PARTY_SEARCH_QUERY = `SET_THIRD_PARTY_SEARCH_QUERY`;
export const INCREMENT_THIRD_PARTY_SEARCH_PAGE = `INCREMENT_THIRD_PARTY_SEARCH_PAGE`;
export const SET_FILL_FOR_STATIC_OBJECT = `SET_FILL_FOR_STATIC_OBJECT`;
export const TOGGLE_STATIC_OBJECTS = `TOGGLE_STATIC_OBJECTS`;
export const SET_BACKGROUND_COLOR = `SET_BACKGROUND_COLOR`;
export const SET_FOR_ALL_SIDES = `SET_FOR_ALL_SIDES`;
export const GET_THREE_D_VIEWER = `GET_THREE_D_VIEWER`;
export const DESTROY_TILING = `DESTROY_TILING`;
export const CREATE_TILING = `CREATE_TILING`;
export const SET_TILE_PADDING = `SET_TILE_PADDING`;
export const RESTORE_DESIGN = `RESTORE_DESIGN`;
export const ADD_OBJECTS_TO_CANVAS = `ADD_OBJECTS_TO_CANVAS`;
export const APPLY_VISIONHUB_FILTER = `APPLY_VISIONHUB_FILTER`;
export const OPEN_DRAW_CONTROL_POPUP = `OPEN_DRAW_CONTROL_POPUP`;
export const CLOSE_DRAW_CONTROL_POPUP = `CLOSE_DRAW_CONTROL_POPUP`;
